import { Component, Vue } from 'vue-property-decorator'

// Components
import FieldText from '@/components/fields/FieldText.vue'
import FieldTextarea from '@/components/fields/FieldTextarea.vue'
import FieldNumber from '@/components/fields/FieldNumber.vue'
import FieldDate from '@/components/fields/FieldDate.vue'
import FieldList from '@/components/fields/FieldList.vue'
import FieldNumeric from '@/components/fields/FieldNumeric.vue'
import FieldBoolean from '@/components/fields/FieldBoolean.vue'

@Component({
  components: {
    FieldText, FieldTextarea, FieldDate, FieldNumber, FieldList, FieldNumeric, FieldBoolean
  }
})
export default class Field extends Vue {

  fieldLabel(field) {
    return field.required ? `${field.title} *` : field.title
  }

  fieldComponent(type) {
    switch (type) {
      case 'text':
        return FieldText
        break
      case 'boolean':
        return FieldBoolean
        break
      case 'number':
        return FieldNumber
        break
      case 'numeric':
        return FieldNumeric
        break
      case 'list':
        return FieldList
        break
      case 'scan':
        return FieldText
        break
      // doesn't exists in API
      case 'note':
        return FieldTextarea
        break
      case 'map':
        return FieldText
        break
      case 'date':
        return FieldDate
        break
      case 'datetime':
        return FieldText
        break
    }
  }
}
